import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, session, loading, isSessionValid, forceLogout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!user || !session) {
        console.log('No user or session, redirecting to login');
        navigate('/login');
        return;
      }
      
      // Check if session is still valid
      if (!isSessionValid()) {
        console.warn('Session is invalid, forcing logout and redirecting to login');
        forceLogout().then(() => {
          navigate('/login');
        }).catch((error) => {
          console.error('Error during force logout:', error);
          navigate('/login');
        });
        return;
      }
    }
  }, [user, session, loading, navigate, isSessionValid, forceLogout]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center gap-2">
            <Loader2 className="w-6 h-6 animate-spin" />
            <span>Yükleniyor...</span>
          </div>
          <p className="text-sm text-muted-foreground">
            Oturum bilgileri kontrol ediliyor...
          </p>
        </div>
      </div>
    );
  }

  if (!user || !session || !isSessionValid()) {
    return null; // Will redirect via useEffect
  }

  return <>{children}</>;
};

export default ProtectedRoute;
